import { initial as zoomConfig } from '../../../config/zoom';
import { TYPES, appContainer } from '../../../inversify.config';
import { IViewerStoreInjector } from '../../../store';

export const pinchZoomOutShortcut = {
  key: new Set(['PinchZoomOut']),
  callBackFunction: () => {
    const { zoom, setZoom, setViewOptions } = appContainer
      .get<IViewerStoreInjector>(TYPES.Store.Viewer)
      .getState();

    if (zoom <= zoomConfig.minZoom) return;

    setViewOptions(null);
    setZoom(zoom - zoomConfig.zoomStep / 5);
  },
};
